import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ReactSlider from "react-slider";
import { useState } from "react";

const ModalGenerateForecast = (props) => {
  return (
    <div>
      <Modal
        show={props.isShowWindow}
        onHide={props.onHide}
        size="lg"
        centered={true}
        backdrop={true}
      >
        <Modal.Body>
          <h4 className="mt-2 mb-4">{props.title}</h4>
          <form>
            <div className="mb-3">
              <p>FORECASTING ERROR</p>
              <ReactSlider
                step={0.01}
                min={0.0}
                max={1.0}
                className="horizontal-slider"
                thumbClassName="example-thumb"
                trackClassName="example-track"
                onChange={props?.handleForecastingError}
                renderThumb={(props, state) => (
                  <div {...props}>{state.valueNow}</div>
                )}
              />
              <br />
              <p>AGGREGATION PERIOD</p>
              <div>
                <label className="distribution-label">
                  <button
                    id="MONTH"
                    className="large-button yellow"
                    onClick={props.handleAggregationPeriod}
                  >
                    MONTH
                  </button>
                </label>
                <label className="distribution-label">
                  <button
                    id="WEEK"
                    className="large-button yellow"
                    onClick={props.handleAggregationPeriod}
                  >
                    WEEK
                  </button>
                </label>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="large-button grey" onClick={props.onHide}>
            CLOSE
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default ModalGenerateForecast;
